import Link from "@mui/material/Link";
import { styled } from "@mui/material/styles";
import { grey } from "designSystem/styles/color";
import OverflowText from "designSystem/components/text/OverflowText";
import Text from "designSystem/components/text/Text";
import { CommentDetail } from "csi/state/comments";
import React, { Fragment, FunctionComponent } from "react";

const StyledText = styled(Text)(() => ({
	color: grey[900],
	marginLeft: 8,
}));

interface CommentAuthorAndDateProps {
	commentDetail: CommentDetail;

	/** indicates if render as a link */
	renderAsLink?: boolean;
}

const CommentAuthorAndDate: FunctionComponent<CommentAuthorAndDateProps> = ({ commentDetail, renderAsLink }) => {
	const {
		authorHref,
		authorName,
		date,
	} = commentDetail;

	return (
		<>
			{renderAsLink ? (
				<Link href={authorHref}>
					<OverflowText text={authorName} />
				</Link>
			)
				:
				<OverflowText bold text={authorName} />
			}
			<StyledText
				grow
				noWrap
				text={date}
			/>
		</>
	);
};

export default CommentAuthorAndDate;